import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Combines class names using clsx and merges Tailwind classes intelligently.
 * This is the standard utility for conditional and merged class names.
 *
 * @param inputs - Class values to combine (strings, objects, arrays)
 * @returns Merged class string with Tailwind conflicts resolved
 *
 * @example
 * cn('px-4 py-2', isActive && 'bg-blue-500', { 'opacity-50': isDisabled })
 * // Returns: "px-4 py-2 bg-blue-500" (if isActive is true, isDisabled is false)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

